import { useMutation } from '@apollo/client';
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  IconButton,
  PrimaryButton,
  Stack,
} from '@fluentui/react';
import { cutToast } from 'utility/toast';
import { useState } from 'react';
import DELETE_TEST from '../ApprovalTestItemDelete.graphql';
import {
  ApprovalTestItemDelete,
  ApprovalTestItemDeleteVariables,
} from '../__generated__/ApprovalTestItemDelete';
import TEST_GROUPS from '../../../TestGroupsModal/ApprovalTestGroups.graphql';
import GET_APPROVAL_DETAILS from '../../../../../../../FlowApproval.graphql';
import APPROVAL_TEST_RESULTS from '../../../../ApprovalTestResults.graphql';

const DELETE_SUBTEXT =
  'This will remove the test from all approvals currently using these test values.';

export const TestItemDelete: React.FC<{
  id: string;
  rowTimestamp: string;
  onClose?: () => void;
  approvalId: string;
}> = ({ id, rowTimestamp, onClose, approvalId }) => {
  const [showDialog, setShowDialog] = useState(false);

  const [DeleteTest] = useMutation<
    ApprovalTestItemDelete,
    ApprovalTestItemDeleteVariables
  >(DELETE_TEST);

  const onDelete = async () => {
    const { errors } = await DeleteTest({
      variables: {
        input: {
          entityDelete: [
            {
              id,
              rowTimestamp,
            },
          ],
        },
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: TEST_GROUPS,
          variables: {
            filter: {
              approvalId: { equalTo: approvalId },
            },
            orderBy: '_FULL_COMMENT_ASC',
          },
        },
        {
          query: GET_APPROVAL_DETAILS,
          variables: {
            id: approvalId!,
          },
        },
        {
          query: APPROVAL_TEST_RESULTS,
          variables: {
            filter: {
              approvalId: { equalTo: approvalId! },
            },
            orderBy: '_FULL_COMMENT_ASC',
          },
        },
      ],
    });
    if (errors?.length) {
      cutToast.error(errors[0].message);
    } else {
      setShowDialog(false);

      cutToast.success('Test item deleted successfully');
      onClose?.();
    }
  };
  return (
    <Stack>
      <IconButton
        iconProps={{ iconName: 'Delete' }}
        title="Delete Test Item"
        ariaLabel="Delete Test Item"
        onClick={() => setShowDialog(true)}
        disabled={!id}
      />
      {showDialog && (
        <Dialog
          hidden={false}
          onDismiss={() => {
            setShowDialog(false);
          }}
          dialogContentProps={{
            type: DialogType.normal,
            title: 'Are you sure?',
            subText: DELETE_SUBTEXT,
          }}
        >
          <DialogFooter>
            <PrimaryButton onClick={onDelete} text="Remove" />
            <DefaultButton
              onClick={() => {
                setShowDialog(false);
              }}
              text="Cancel"
            />
          </DialogFooter>
        </Dialog>
      )}
    </Stack>
  );
};
